const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefilSavingsReminderIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "daily dose reminder active",
    d: "M0 6.938V5.25A2.251 2.251 0 0 1 2.25 3H4.5V.563A.564.564 0 0 1 5.063 0h1.875A.564.564 0 0 1 7.5.563V3h6V.563A.564.564 0 0 1 14.063 0h1.875a.564.564 0 0 1 .562.563V3h2.25A2.251 2.251 0 0 1 21 5.25v1.688a.564.564 0 0 1-.562.563H.563A.564.564 0 0 1 0 6.938zm21 2.625V21.75A2.251 2.251 0 0 1 18.75 24H2.25A2.251 2.251 0 0 1 0 21.75V9.563A.564.564 0 0 1 .563 9h19.875a.564.564 0 0 1 .562.563zm-10.5 8.812a1.875 1.875 0 1 0 1.875 1.875 1.874 1.874 0 0 0-1.875-1.875zM8.662 11.85 9 17.1a.56.56 0 0 0 .563.525h1.875A.564.564 0 0 0 12 17.1l.338-5.25a.564.564 0 0 0-.562-.6H9.225a.567.567 0 0 0-.562.6z",
    style: {
      fill: "#003d4c"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefilSavingsReminderIconActive);
export default __webpack_public_path__ + "static/media/refil_savings_reminder_icon_active.de4cecaa6ba023d7956df897a069dde7.svg";
export { ForwardRef as ReactComponent };